import React from "react";
import { formatTime } from "../../../shared/dateTimeUtils";
import _ from "lodash";

export default function MonitorTile({ model, prefs, formatDate }) {
  const hours = _.get(prefs, "userPreferences.server.pm.dataRangeInHours");
  const groupedEvents = _.groupBy(model.eventData, (event) =>
    formatDate(event.eventTime),
  );
  return (
    <React.Fragment>
      <div className="title">
        Monitor{" "}
        {hours
          ? hours < 24
            ? `(${hours}h)`
            : `(${Math.ceil(hours / 24)}d)`
          : null}
        <span className="count">{model.count}</span>
      </div>
      <div className="tile-content monitor">
        {model.status.toLowerCase() === "na" ? (
          <div className="no-results">No monitor data</div>
        ) : (
          [
            <div
              className={`status ${model.status.toLowerCase()}`}
              key="status"
            >
              {model.status.toLowerCase()}
            </div>,
            model.eventData.length ? (
              Object.keys(groupedEvents).map((date, i) => (
                <div className="day-group" key={`${date}-${i}`}>
                  <div className="day">{date}</div>
                  {groupedEvents[date].map((event, i2) => (
                    <div className="event" key={`${event.eventTime}-${i2}`}>
                      <div
                        className={`level ${event.level.toLowerCase()}`}
                      ></div>
                      <div className="message">{event.message}</div>
                      <div className="time">{formatTime(event.eventTime)}</div>
                    </div>
                  ))}
                </div>
              ))
            ) : (
              <div className="no-results" key="no-results">
                No Events
              </div>
            ),
          ]
        )}
      </div>
    </React.Fragment>
  );
}
